const clientLogos = [
  { name: "SSE", src: "/lovable-uploads/logo-sse.webp" },
  { name: "National Grid", src: "/lovable-uploads/logo-national-grid.webp" },
  { name: "Thames Water", src: "/lovable-uploads/logo-thames-water.webp" },
  { name: "Openreach", src: "/lovable-uploads/logo-openreach.webp" },
  { name: "Network Rail", src: "/lovable-uploads/logo-network-rail.webp" },
  { name: "Mitie", src: "/lovable-uploads/logo-mitie.webp" },
  { name: "Balfour Beatty", src: "/lovable-uploads/logo-balfour-beatty.webp" },
  { name: "Kier", src: "/lovable-uploads/logo-kier.webp" },
  { name: "Morgan Sindall", src: "/lovable-uploads/logo-morgan-sindall.webp" },
  { name: "Galliford Try", src: "/lovable-uploads/logo-galliford-try.webp" },
  { name: "Willmott Dixon", src: "/lovable-uploads/logo-willmott-dixon.webp" },
  { name: "EDF", src: "/lovable-uploads/logo-edf.webp" },
  { name: "Ørsted", src: "/lovable-uploads/logo-orsted.webp" },
];

const LogoItem = ({ logo }: { logo: typeof clientLogos[0] }) => (
  <div className="flex items-center justify-center w-[160px] h-[56px] shrink-0">
    <img
      src={logo.src}
      alt={`${logo.name} logo`}
      loading="lazy"
      decoding="async"
      width={160}
      height={56}
      className="max-w-full max-h-full w-auto h-auto object-contain"
    />
  </div>
);

const TrustedBy = () => {
  return (
    <section className="bg-[#09090b] border-t border-white/[.07] border-b border-b-white/[.07] py-14 max-md:py-8 px-[80px] max-md:px-4">
      <h2 className="text-[32px] max-md:text-[24px] font-extrabold text-white tracking-[-0.64px] leading-[1.15] text-center mb-6 max-md:mb-8 capitalize">
        Trusted by 100+ UK teams at
      </h2>
      <div className="overflow-hidden relative">
        <div className="absolute top-0 bottom-0 left-0 w-10 z-10 pointer-events-none bg-gradient-to-r from-[#09090b] to-transparent" />
        <div className="absolute top-0 bottom-0 right-0 w-10 z-10 pointer-events-none bg-gradient-to-l from-[#09090b] to-transparent" />
        <div className="flex animate-marquee-fast max-md:animate-marquee-mobile hover:[animation-play-state:paused]">
          <div className="flex items-center gap-[10px] max-md:gap-[2px] shrink-0">
            {clientLogos.map((logo) => (
              <LogoItem key={logo.name} logo={logo} />
            ))}
          </div>
          <div className="flex items-center gap-[10px] max-md:gap-[2px] shrink-0 ml-[10px] max-md:ml-[2px]">
            {clientLogos.map((logo) => (
              <LogoItem key={`${logo.name}-dup`} logo={logo} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;